import { render } from "./TrailerComponent.vue?vue&type=template&id=23ed955a&scoped=true"
import script from "./TrailerComponent.vue?vue&type=script&lang=js"
export * from "./TrailerComponent.vue?vue&type=script&lang=js"

import "./TrailerComponent.vue?vue&type=style&index=0&id=23ed955a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ed955a"]])

export default __exports__